
export const setPlatos = ( state, platos ) => {
    state.platos = platos
}

export const setEntradas = ( state, entradas ) => {
    state.entradas = entradas
}